import { observer } from "mobx-react-lite";
import PasswordForm from "./PasswordForm";
import useJoinPwdSettingView from "../useJoinPwdSettingView";
    
interface IProps {
    onClick: () => void;
}

const JoinPwdSettingView = observer(({onClick}: IProps) => {
    const {password,checkPassword, isCompleteBtnDisabled, isPasswordValid, isCheckPasswordDisabled, onChangePassword, onChangeCheckPassword, onClickCompleteBtn, onBlurPassword, onKeyDownCheckPassword} = useJoinPwdSettingView(onClick);

    return (
        <div className="wrap wrap_temporary logn">
            <div className="container">
            <PasswordForm
                password={password}
                checkPassword={checkPassword}
                isCompleteBtnDisabled={isCompleteBtnDisabled}
                isPasswordValid={isPasswordValid}
                isCheckPasswordDisabled={isCheckPasswordDisabled}
                onChangePassword={onChangePassword}
                onChangeCheckPassword={onChangeCheckPassword}
                onClickCompleteBtn={onClickCompleteBtn}
                onBlurPassword={onBlurPassword}
                onKeyDownCheckPassword={onKeyDownCheckPassword}
            />
            </div>
        </div> 
    )
});

export default JoinPwdSettingView;  